export const AUTH_REQUEST = "AUTH_REQUEST";
export const PEM_REQUEST = "PEM_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const PEM_SUCCESS = "PEM_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_SET_TOKEN = "AUTH_SET_TOKEN";
export const AUTH_SET_ID = "AUTH_SET_ID";
